<template>
  <div class="w-100">
    <ModalConfirm
      modalId="categoryModal"
      :text="`Are you sure want to delete this Content Text?`"
      @onClick="handleDelete(id)"
      :center="true"
      :buttonConfig="{
        cancelText: 'CANCEL',
        confirmText: `CONFIRM`,
      }"
    />
    <TableBasic :payload="payload" @onChange="changeParameter">
      <template v-slot:empty_table>
        <div class="empty-table">
          <span> No data found on this list </span>
        </div>
      </template>
      <template v-slot:created_at="{ value }">
        <div>
          {{ filters.dateSimple(value) }}
        </div>
      </template>
      <template v-slot:param="{ value }">
        <div>
          {{ value.join(", ") }}
        </div>
      </template>
      <template v-slot:value="{ value }">
        <div
          :style="{
            maxWidth: '300px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }"
        >
          {{ filters.richContentToString(value) }}
        </div>
      </template>
      <template v-slot:actions="{ value }">
        <div>
          <router-link
            :to="value.url"
            class="btn"
            :class="value.edit == 'disable' ? 'disabled' : ''"
          >
            <img src="@/assets/ic_edit.svg" alt="edit" />
          </router-link>
          <button
            class="btn"
            @click="setIdCategory(value.id)"
            data-bs-toggle="modal"
            data-bs-target="#categoryModal"
          >
            <img
              src="@/assets/images/ic_delete.png"
              style="max-width: 24px"
              alt="delete"
            />
          </button>
        </div>
      </template>
    </TableBasic>
  </div>
</template>

<script>
import TableBasic from "@/components/TableBasic.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";

export default {
  components: {
    TableBasic,
    ModalConfirm,
  },
  data() {
    return {
      id: "",
      payload: {
        header: [
          {
            key: "created_at",
            label: "CREATED DATE",
            class: "text-justify",
            sort: false,
            sort_key: "created_at",
          },
          {
            key: "content_title",
            label: "CONTENT TEXT TITLE",
            class: "text-justify",
            sort: false,
            sort_key: "content_title",
          },
          {
            key: "param",
            label: "PARAM",
            class: "text-justify",
            sort: false,
            sort_key: "param",
          },
          {
            key: "value",
            label: "VALUE",
            class: "text-justify",
            sort: false,
            sort_key: "value",
          },
          {
            key: "actions",
            label: "ACTIONS",
            class: "text-justify",
          },
        ],
        value: [],
        filter: true,
        filterLabel: "By Created date",
        hideFilterDate: true,
        search: true,
        searchInput: "",
        searchPlaceholder: "Search by title or description",
        searchContainerStyle: {
          maxWidth: "215px",
        },
        button_name: "Add New",
        button_link: "content-text/add",
        icon_button: "add",
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
      },
      listPromo: [],
    };
  },
  async mounted() {
    this.getData();
  },
  methods: {
    changeParameter(value) {
      console.log(value);
      this.payload.perPage = value.per_page;
      this.payload.currentPage = value.current_page;
      this.payload.searchInput = value.search;
      this.payload.sortType = value.sort_type;
      this.payload.sortBy = value.sort_by;
      this.getData();
    },
    setIdCategory(value) {
      this.id = value;
    },

    async getData() {
      let payload = {
        page: this.payload.currentPage,
        size: this.payload.perPage,
      };
      if (this.payload.searchInput != "") {
        payload.keyword = this.payload.searchInput;
      }

      // uncomment if BE provided sort by
      // if (this.sortBy != "") {
      //   payload.sort_by = this.payload.sortBy;
      //   payload.sort_type = this.payload.sortType;
      // }

      const res = await this.$store.dispatch("contentText/getAll", payload);
      let getterData = this.$store.getters["contentText/parsedContentText"];
      this.payload.value = getterData;
      this.payload.totalRows = res.data.data.count;
    },

    async handleDelete(id) {
      try {
        await this.$store.dispatch("contentText/delete", id);
        this.$swal({
          icon: "success",
          title: "Success delete content text",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          this.getData();
        });
      } catch (error) {
        this.$swal({
          title:
            error.response?.data?.errorMessage ||
            error.message ||
            "Something went wrong",
          icon: "warning",
          timer: 2000,
        });
      }
    },
  },
};
</script>

<style scoped>
.empty-table {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f2f8;
  color: #424143;
  height: 3rem;
}
</style>
